import React, { useState, useEffect, useRef } from "react";
import ScriptEditor from "./ScriptEditor";
import Box from "@mui/material/Box";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ReplayIcon from "@mui/icons-material/Replay";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "@mui/material/Button";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import "react-reflex/styles.css";
import "../../assets/css/editor.scss";
import { useTranslation } from "react-i18next";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import * as br from "../../utils/browserDetect";

function EditorComponent() {
  const [HwpCtrl, setHwpCtrl] = useState();
  const [HwpIframeMsg, setHwpIframeMsg] = useState();
  const editorRef = useRef();
  const { t } = useTranslation("translation");
  const [browser, setBrowser] = useState({ isBrowser: false, name: "" });
  const [errOpen, setErrOpen] = useState(false);

  useEffect(() => {
    isBrowserCheck();
  }, []);

  useEffect(() => {
    if (!browser.name) return;
    browser.isBrowser
      ? window.addEventListener("message", receiveMessage, false)
      : setErrOpen(true);
  }, [browser]);

  function isBrowserCheck() {
    const info = br.getInfo();
    if (
      info.BrowserInfo["isIE"] ||
      info.BrowserInfo["isIE11"] ||
      info.BrowserInfo["isChrome"] ||
      info.BrowserInfo["isEdge"]
    )
      setBrowser({ isBrowser: true, name: info.BrowserInfo.name });
    else setBrowser({ isBrowser: false, name: info.BrowserInfo.name });
  }

  function receiveMessage(event) {
    const HwpFrame = document.getElementById("Document_HwpCtrl");
    setHwpCtrl(HwpFrame.contentWindow.HwpCtrl);
    setHwpIframeMsg(event.data);
  }

  const iframeHwpCtrlPart = () => {
    return {
      __html:
        '<iframe id="Document_HwpCtrl" src="/hwpctrl.html?id=hwpctrl1"  frameborder=0 ></iframe>',
    };
  };

  return (
    <Box id="editor-component">
      <ReflexContainer orientation="vertical">
        {/* btn + editor component */}
        <ReflexElement className="reflex-component">
          <ReflexContainer orientation="horizontal">
            {/* btn */}
            <ReflexElement flex={0.06} className="reflex-component">
              <Button
                className="btn init"
                variant="outlined"
                onClick={() =>
                  browser.isBrowser && editorRef.current.initEditorBtn()
                }
              >
                <p>{t("content.btn.init")}</p>
                <ReplayIcon />
              </Button>
              <Button
                className="btn run"
                variant="contained"
                onClick={() =>
                  browser.isBrowser && editorRef.current.executeEditorBtn()
                }
                id="gtm-tracking-id=try_demos"
              >
                <p>{t("content.btn.exe")}</p>
                <ArrowForwardIcon />
              </Button>
            </ReflexElement>

            {/* script editor + webhwpctrl */}
            <ReflexElement flex={0.94} className="reflex-component">
              <ReflexContainer orientation="vertical">
                {/* script editor */}
                <ReflexElement className="left-pane" minSize="300" flex={0.35}>
                  <ScriptEditor
                    hwpCtrl={HwpCtrl}
                    hwpCtrlMsg={HwpIframeMsg}
                    ref={editorRef}
                  />
                </ReflexElement>

                {/* splitter */}
                <ReflexSplitter className="center-splitter">
                  <Box className="arrow-icon">
                    <ArrowLeftIcon
                      className="left-arrow-icon"
                      color="primary"
                    />
                    <ArrowRightIcon
                      className="right-arrow-icon"
                      color="primary"
                    />
                  </Box>
                </ReflexSplitter>

                {/* webhwpctrl */}
                <ReflexElement className="right-pane" minSize="300">
                  {browser.isBrowser ? (
                    <Box
                      id="hwpctrl"
                      sx={{ height: "100%" }}
                      dangerouslySetInnerHTML={iframeHwpCtrlPart()}
                    />
                  ) : (
                    <Box sx={{ bgcolor: "#D3D3D3", height: "100%" }} />
                  )}
                </ReflexElement>
              </ReflexContainer>
            </ReflexElement>
          </ReflexContainer>
        </ReflexElement>
      </ReflexContainer>

      {/* browser msgbox */}
      <Snackbar
        open={errOpen}
        sx={{ height: "50%" }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={() => {
            setErrOpen(false);
          }}
          severity="error"
        >
          <AlertTitle>Error</AlertTitle>
          <span>
            <b>{browser.name}</b>에서는 예제를 실행할 수 없습니다. 현재 지원되는
            웹 브라우저는 edge와 chrome입니다.
          </span>
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default EditorComponent;
